module.exports = __webpack_public_path__ + "img/xp.066eb8f9.svg";